const SMALL = 'small';
const LARGE = 'large';

const TOP_DESTINATIONS = [
    {
        id: 'Dubai',
        title: 'Dubai',
        sub_title: '2,244 properties',
        image: 'leisure_destinations/dubai.jpg',
        destination: {
            "address": "Dubai - United Arab Emirates",
            "place": {
                "description": "Dubai - United Arab Emirates",
                "place_id": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "reference": "ChIJRcbZaklDXz4RYlEphFBu5r0",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "Dubai",
                "label": "Dubai, United Arab Emirates",
                "address": "Dubai - United Arab Emirates",
                "short_address": "United Arab Emirates",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "Dubai",
                        "short_name": "Dubai",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "Dubai",
                        "short_name": "Dubai",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United Arab Emirates",
                        "short_name": "AE",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "Dubai - United Arab Emirates",
                "geometry": {
                    "location": {
                        "lat": 25.2048493,
                        "lng": 55.2707828
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 25.35856066265986,
                            "lng": 55.5650392624228
                        },
                        "southwest": {
                            "lat": 24.79348418590246,
                            "lng": 54.89045432509004
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 25.2048493,
                    "lng": 55.2707828
                },
                "viewport": {
                    "northeast": {
                        "lat": 25.35856066265986,
                        "lng": 55.5650392624228
                    },
                    "southwest": {
                        "lat": 24.79348418590246,
                        "lng": 54.89045432509004
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'NewYork',
        title: 'New York',
        sub_title: '876 properties',
        image: 'leisure_destinations/new-york.jpg',
        destination: {
            "address": "New York, NY, USA",
            "place": {
                "description": "New York, NY, USA",
                "place_id": "ChIJOwg_06VPwokRYv534QaPC8g",
                "reference": "ChIJOwg_06VPwokRYv534QaPC8g",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "New York",
                "label": "New York, NY, USA",
                "address": "New York, NY, USA",
                "short_address": "NY, USA",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "New York",
                        "short_name": "New York",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "New York",
                        "short_name": "NY",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United States",
                        "short_name": "US",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "New York, NY, USA",
                "geometry": {
                    "location": {
                        "lat": 40.7127753,
                        "lng": -74.0059728
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 40.91757705070789,
                            "lng": -73.70027206817629
                        },
                        "southwest": {
                            "lat": 40.47739906045452,
                            "lng": -74.25908991427882
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 40.7127753,
                    "lng": -74.0059728
                },
                "viewport": {
                    "northeast": {
                        "lat": 40.91757705070789,
                        "lng": -73.70027206817629
                    },
                    "southwest": {
                        "lat": 40.47739906045452,
                        "lng": -74.25908991427882
                    }
                }
            }
        },
        type: SMALL
    },
    {
        id: 'London',
        title: 'London',
        sub_title: '4,950 properties',
        image: 'leisure_destinations/london.jpg',
        destination: {
            "address": "London, UK",
            "place": {
                "description": "London, UK",
                "place_id": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                "reference": "ChIJdd4hrwug2EcRmSrV3Vo6llI",
                "types": [
                    "locality",
                    "political"
                ],
                "category": "location",
                "name": "London",
                "label": "London, UK",
                "address": "London, UK",
                "short_address": "UK",
                "index": -1,
                "address_components": [
                    {
                        "long_name": "London",
                        "short_name": "London",
                        "types": [
                            "locality",
                            "political"
                        ]
                    },
                    {
                        "long_name": "London",
                        "short_name": "London",
                        "types": [
                            "postal_town"
                        ]
                    },
                    {
                        "long_name": "Greater London",
                        "short_name": "Greater London",
                        "types": [
                            "administrative_area_level_2",
                            "political"
                        ]
                    },
                    {
                        "long_name": "England",
                        "short_name": "England",
                        "types": [
                            "administrative_area_level_1",
                            "political"
                        ]
                    },
                    {
                        "long_name": "United Kingdom",
                        "short_name": "GB",
                        "types": [
                            "country",
                            "political"
                        ]
                    }
                ],
                "formatted_address": "London, UK",
                "geometry": {
                    "location": {
                        "lat": 51.5072178,
                        "lng": -0.1275862
                    },
                    "viewport": {
                        "northeast": {
                            "lat": 51.67234324898703,
                            "lng": 0.1482710335611201
                        },
                        "southwest": {
                            "lat": 51.38494012429096,
                            "lng": -0.3514683384218145
                        }
                    }
                },
                "icon": "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/geocode-71.png",
                "location": {
                    "lat": 51.5072178,
                    "lng": -0.1275862
                },
                "viewport": {
                    "northeast": {
                        "lat": 51.67234324898703,
                        "lng": 0.1482710335611201
                    },
                    "southwest": {
                        "lat": 51.38494012429096,
                        "lng": -0.3514683384218145
                    }
                }
            }
        },
        type: LARGE
    }
];

module.exports = {
    SMALL,
    LARGE,
    TOP_DESTINATIONS
}
